import { render, staticRenderFns } from "./ExerciseOutro.vue?vue&type=template&id=d22b7cfe"
import script from "./ExerciseOutro.vue?vue&type=script&lang=js"
export * from "./ExerciseOutro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports